import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCameraNew = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 20,
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13.002 9a4 4 0 1 1-8 0 4 4 0 0 1 8 0zm-2 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.443 0 4.586 3H0v13h18V3h-4.586l-1.857-3H6.443zm1.114 2h2.886L12.3 5H16v9H2V5h3.7l1.857-3z",
		fill: "currentColor"
	})]
});
export default SvgCameraNew;
